/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrmarginstandard2Inputs */

const en_qrmarginstandard2 = /** @type {(inputs: Qrmarginstandard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const de_qrmarginstandard2 = /** @type {(inputs: Qrmarginstandard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

/**
* | output |
* | --- |
* | "Standard" |
*
* @param {Qrmarginstandard2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrmarginstandard2 = /** @type {((inputs?: Qrmarginstandard2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrmarginstandard2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrmarginstandard2(inputs)
	return de_qrmarginstandard2(inputs)
});
export { qrmarginstandard2 as "qrMarginStandard" }